module.exports = __webpack_public_path__ + "img/SAND.b245ea6d.svg";